import { render } from "./EditColorsModal.vue?vue&type=template&id=b1b58344&scoped=true"
import script from "./EditColorsModal.vue?vue&type=script&lang=js"
export * from "./EditColorsModal.vue?vue&type=script&lang=js"

import "./EditColorsModal.vue?vue&type=style&index=0&id=b1b58344&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1b58344"]])

export default __exports__